import React, { useEffect } from "react";
import { Table, Input, DatePicker, Select, Form, Radio, Alert, Row, Card } from "antd";
import dayjs from "dayjs";
import locale from "antd/es/date-picker/locale/fr_FR";
import classes from "../../../Etablissements/Etablissements.module.css";
import { useTranslation } from "react-i18next";
const { Option } = Select;

const EtapeListeApprenantsFNH = ({ form, globalData,id_session_formation }) => {
  const nbLignes = globalData?.nb_apprenants 
 const { t, i18n } = useTranslation();
   const niveauScolaire = [
    {
      value: "إبتدائي",
      label: "Primaire - إبتدائي",
    },
    {
      value: "ثانوي",
      label: "Secondaire - ثانوي",
    },
    {
      value: "جامعي",
      label: "Universitaire - جامعي",
    },
    {
      value: "تكوين مهني",
      label: "Formation professionnelle - تكوين مهني",
    },
  ];
  useEffect(() => {
    
    const currentValues = form.getFieldValue("apprenants") || [];
    if (currentValues.length < nbLignes) {
      const newApprenants = [...currentValues];
      for (let i = currentValues.length; i < nbLignes; i++) {
        newApprenants.push({
          typeIdentifiant: "cin",
        });
      }
      form.setFieldsValue({ apprenants: newApprenants });
    }
  }, [nbLignes]);

  const columns = [
    {
      title: "Type",
      dataIndex: "typeIdentifiant",
      width: 150,
      render: (_, field) => (
        <Form.Item
          {...field}
          name={[field.name, "typeIdentifiant"]}
          noStyle
          initialValue="cin"
        >
          <Radio.Group size="small" disabled={id_session_formation}>
            <Radio.Button value="cin">CIN</Radio.Button>
            <Radio.Button value="extrait">Extrait</Radio.Button>
          </Radio.Group>
        </Form.Item>
      ),
    },
    {
      title: "Nom",
      dataIndex: "nom",
      width: 150,
      render: (_, field) => (
        <Form.Item
          {...field}
          name={[field.name, "nom"]}
          rules={[{ required: true, message:t("Veuillez remplir ce champ.") }]}
          noStyle
        >
          <Input size="small" placeholder="Nom" disabled={id_session_formation}/>
        </Form.Item>
      ),
    },
    {
      title: "Prénom",
      dataIndex: "prenom",
      width: 150,
      render: (_, field) => (
        <Form.Item
          {...field}
          name={[field.name, "prenom"]}
          rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
          noStyle
        >
          <Input size="small" placeholder="Prénom" disabled={id_session_formation} />
        </Form.Item>
      ),
    },
    {
      title: "Identifiant",
      dataIndex: "identifiant",
      width: 150,
      render: (_, field) => (
        <Form.Item
          shouldUpdate={(prev, curr) =>
            prev.apprenants?.[field.name]?.typeIdentifiant !==
            curr.apprenants?.[field.name]?.typeIdentifiant
          }
          noStyle
        >
          {() => {
            const type = form.getFieldValue(["apprenants", field.name, "typeIdentifiant"]) || "cin";
            const rules = [
              { required: true, message: "Champ requis" },
              {
                pattern: type === "cin" ? /^\d{8}$/ : /^\d{10}$/,
                message:
                  type === "cin"
                    ? "Le CIN doit contenir exactement 8 chiffres"
                    : "L'extrait doit contenir exactement 10 chiffres",
              },
            ];
            return (
              <Form.Item
                {...field}
                name={[field.name, "identifiant"]}
                rules={rules}
                noStyle
              >
                <Input
                disabled={id_session_formation}
                  size="small"
                  maxLength={type === "cin" ? 8 : 10}
                  placeholder="Identifiant"
                />
              </Form.Item>
            );
          }}
        </Form.Item>
      ),
    },
    {
      title: "Date de naissance",
      dataIndex: "dateNaissance",
      width: 150,
      render: (_, field) => (
        <Form.Item
          {...field}
          name={[field.name, "dateNaissance"]}
          rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
          noStyle
        >
          <DatePicker
          disabled={id_session_formation}
            size="small"
            locale={locale}
            format="DD/MM/YYYY"
            style={{ width: "100%" }}
            disabledDate={(current) => current && current > dayjs()}
          />
        </Form.Item>
      ),
    },
    {
      title: "Structure",
      dataIndex: "structure",
      width: 150,
      render: (_, field) => (
        <Form.Item
          {...field}
          name={[field.name, "structure"]}
          rules={[{ required: true, message: t("Veuillez remplir ce champ.")}]}
          noStyle
        >
          <Select size="small" placeholder="Structure" disabled={id_session_formation} >
            <Option value="Structure A">Structure A</Option>
            <Option value="Structure B">Structure B</Option>
            <Option value="Structure C">Structure C</Option>
          </Select>
        </Form.Item>
      ),
    },
    {
      title: "Niveau",
      dataIndex: "niveau",
      width: 150,
      render: (_, field) => (
        <Form.Item
          {...field}
          name={[field.name, "niveau"]}
          rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
          noStyle
        >
          <Select size="small" placeholder="Niveau" options={niveauScolaire} disabled={id_session_formation}>
            {/* <Option value="Débutant">Débutant</Option>
            <Option value="Intermédiaire">Intermédiaire</Option>
            <Option value="Avancé">Avancé</Option> */}
          </Select>
        </Form.Item>
      ),
    },
  ];

  return (

    <div>

 <Row className={classes.listeRow}>

 <Card
     className={classes.listeCard}
     style={{ marginBottom: "40px" }}
     bordered={false}
    //  title={
    //    <div       style={{ textAlign: i18n?.dir() === "ltr" ? "left" : "right" ,   fontSize:"18px",
    //      fontWeight:"600",
    //       color:"#195a99" }}>
    //      {t("Participants")}
    //    </div>
    //  }
 
     
   >

<Alert type="info"   
    style={{ marginTop: "20px" }}
  message="Configuration"
 description={`Ajout des participants`}  showIcon />
 <Form.List name="apprenants">
    {(fields) => (
        <Table
        style={{ marginTop: "20px" }}
          size="small"
          dataSource={fields}
          pagination={false}
          rowKey={(row) => row.key || row.name}
          columns={columns}
          scroll={{ x: "max-content" }}
        />
      )}
    </Form.List>
     
   </Card>


 </Row>


</div>


  );
};

export default EtapeListeApprenantsFNH;
